import moment from "moment";
import React from "react";
import { getNavigationUrlByEncounterId } from "./encounterNavigationService";

export function transformNotifications(notifications, history, markAsReadNotification) {
    let newNotifications = [];
    let expiredNotifications = [];
    let allNotifications = [];
    if (notifications != null && notifications.length > 0) {
        notifications.forEach(notification => {
            let noOfDaysToExpire = moment(notification.dueDate).diff(moment().toDate(), "days");
            let noOfTimeUnitsAgoCreated = moment(notification.createDate).fromNow(true);

            let isExpired = moment(notification.dueDate).diff(moment().toDate(), "days") < 0;
            let isRead = !isExpired && notification.readDate !== null;

            if (
                notification.messageContent !== null &&
                notification.messageContent != "" &&
                notification.actionTaken === false
            ) {
                let item = {
                    notificationId: notification.globalId,
                    isNew: !isExpired && !isRead,
                    isExpired: isExpired,
                    isRead: isRead,
                    iconColor: noOfDaysToExpire <= 2 ? "#FF663C" : "#FFB507",
                    label: !isExpired ? (
                        <div dangerouslySetInnerHTML={{ __html: notification.messageContent }} />
                    ) : (
                        <div>
                            <p>
                                {getExpiredPartialMessageContent(notification) +
                                    " " +
                                    moment(notification.dueDate).fromNow(true) +
                                    " ago."}
                            </p>
                        </div>
                    ),
                    info: noOfTimeUnitsAgoCreated + " ago",
                    action: () => {
                        markAsReadNotification(notification.notificationId);
                        let url = getNavigationUrlByEncounterId(notification.encounterId, notification.encounterStatus);
                        history.push(url);
                    },
                };

                allNotifications.push(item);
                if (!isRead && !isExpired) {
                    newNotifications.push(item);
                }
                if (isExpired) {
                    expiredNotifications.push(item);
                }
            }
        });
    }

    return { expiredNotifications, allNotifications, newNotifications };
}

function getExpiredPartialMessageContent(notification) {
    if (notification.type.includes("hpe")) {
        return "HPE case expired ";
    }
    if (notification.type.includes("fa")) {
        return "FA case expired ";
    }
    if (notification.type.includes("charity")) {
        return "Charity case expired ";
    }
}
